<nb-tabset>
    <nb-tab tabTitle="Power BI" tabIcon="pie-chart-outline" responsive>
        <app-spinner *ngIf="loading"></app-spinner>
        <div class="wrapperOptions" *ngIf="!loading">
            <nb-select size="small" placeholder="Reportes" [(ngModel)]="rep" (ngModelChange)="reportChange($event)">
                <nb-option *ngFor="let reporte of reportes" [value]="reporte">{{reporte.name}}</nb-option>
            </nb-select>
            <button [disabled]='!report' nbTooltip="Recargar Reporte" nbTooltipPlacement="bottom" class="reportsBtn"
                (click)="reload()">
                <nb-icon nbPrefix icon="refresh-outline"> </nb-icon>
            </button>
            <button [disabled]='!report' nbTooltip="Ver en Pantalla Completa" nbTooltipPlacement="bottom"
                class="reportsBtn" (click)="fullScreen()">
                <nb-icon nbPrefix icon="expand-outline"> </nb-icon>
            </button>
        </div>
        <div id="pbi-container">
            <div class="embed-container"></div>
        </div>
    </nb-tab>
</nb-tabset>